import { createNanoEvents } from 'nanoevents'

export const emitter = createNanoEvents()
